import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, CardHeader, Container } from 'reactstrap';
import BreadcrumbTrail from '../../../../../../../../Common/BreadcrumbTrail';
import { useHistory } from 'react-router-dom';
import AddVendor from '../../../../../ProgramOnboarding/Components/SelectVendor/Components/AddVendor';
import { isValidEmail } from '../../../../../../../../Helpers/Helpers';
import AddClient from '../../../Comman/AddClient';
import { useDispatch, useSelector } from 'react-redux';
import { CREATE_CLIENT_V2, UPDATE_CLIENT_V2 } from '../../../../../../../../../store/actions';
import { ChevronLeft } from 'react-feather';

const initialState = {
  name: '',
  region: null,
  currency: null,
  selectedCarTypes: [],
  client_type: '',
  industry: '',
};

const AddAndUpdateClient = ({ currentSelectedInventory, onClose, isUpdate }) => {
  const dispatch = useDispatch();

  const [client, setClient] = useState(initialState);
  const [errors, setErrors] = useState<any>({});

  const { inventoryView } = useSelector((state: any) => ({
    inventoryView: state?.GetInventoryView?.data,
  }));

  const validate = () => {
    const newErrors: any = {};
    if (!client.name.trim()) newErrors.name = 'Vendor Name is required';
    if (!client.region) newErrors.region = 'Region is required';
    if (!client.client_type) newErrors.client_type = 'Client Type is required';
    if (!client.industry) newErrors.industry = 'Industry is required';
    if (!client.currency) newErrors.currency = 'Currency is required';
    if (client.selectedCarTypes.length === 0) newErrors.selectedCarTypes = 'Please select at least one car type';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    if (currentSelectedInventory) {
      setClient({
        name: currentSelectedInventory?.name,
        region: { value: currentSelectedInventory?.contracting_country?.id, label: currentSelectedInventory?.contracting_country?.name },
        currency: currentSelectedInventory?.currency,
        selectedCarTypes: inventoryView?.clientDetails?.car_types ?? [],
        client_type: currentSelectedInventory?.client_type,
        industry: currentSelectedInventory?.industry,
      });
    }
  }, [currentSelectedInventory]);

  const handleClient = () => {
    if (validate()) {
      const payload = {
        name: client?.name ?? '',
        contracting_country: {
          id: client?.region?.value ?? '',
          name: client?.region?.label ?? '',
          currency: client?.currency?.value ?? '',
        },
        car_types: client?.selectedCarTypes,
        client_type: client?.client_type ?? '',
        industry: client?.industry ?? '',
      };

      if (isUpdate) {
        dispatch({
          type: UPDATE_CLIENT_V2,
          payload: {
            data: { ...payload, id: currentSelectedInventory?.id },
          },
        });
      } else {
        dispatch({
          type: CREATE_CLIENT_V2,
          payload: {
            data: payload,
          },
        });
      }
    }
  };

  return (
    <Card className="p-3">
      <CardHeader tag="h5" className="border-bottom pb-2">
        {isUpdate ? 'Update Client' : 'Add Client'}
      </CardHeader>
      <CardBody>
        <AddClient client={client} setClient={setClient} errors={errors} setErrors={setErrors} state={null} />
        <div className="d-flex justify-content-between mt-4">
          <Button
            onClick={() => {
              setClient(initialState);
              onClose();
            }}
            color="light"
            className="d-flex align-items-center gap-1 px-3 py-2"
            style={{
              backgroundColor: '#E9EBEC', // light gray
              color: '#404B7C', // navy/dark blue
              fontWeight: 500,
              boxShadow: 'none',
              border: 'none',
            }}
          >
            <ChevronLeft size={18} />
            Back
          </Button>

          <Button className="btn btn-primary" color="primary" onClick={handleClient}>
            {isUpdate ? 'Update Client' : 'Add Client'}
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default AddAndUpdateClient;
